import {combineReducers} from "redux";
import * as historyActions from "../actions/historyActions";

function recommendations(state = [], action) {
    switch (action.type) {
        case historyActions.RECEIVE_HISTORY:
            return action.payload;
        default:
            return state;
    }
}

function loading(state = false, action) {
    switch (action.type) {
        case historyActions.REQUEST_HISTORY:
            return true;
        case historyActions.RECEIVE_HISTORY:
            return false;
        default:
            return state;
    }
}

export default combineReducers({
    recommendations,
    loading
});



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/recommendations/historyReducers.js
 **/